// 9fbef606107a605d69c0edbcd8029e5d
import Styled from 'styled-components';

export default Styled.span`
  font-family: Nunito;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  color: ${(props) => props.theme.colors.BLACK.NORMAL};
  min-height: 19px;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: 10px;
  }
`;
